import React, { useState } from "react";
import VideoPlayer from "./VideoPlayer";
import "./App.css";
import ImageLoader from "./ImageLoader";

function support_format_webp() {
  var elem = document.createElement("canvas");

  if (!!(elem.getContext && elem.getContext("2d"))) {
    // was able or not to get WebP representation
    return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
  } else {
    // very old browser like IE 8, canvas not supported
    return false;
  }
}

function App() {
  const [loading, setLoading] = useState(true);
  const onImgClick = () => {
    window.location = window.urlToOpen;
  };
  const onVideoLoad = () => {
    setLoading(false);
  };

  const imgUrl = support_format_webp()
    ? "./assets/Flower Frame 8x10 in roman passage.webp"
    : "./assets/Flower Frame 8x10 in roman passage.png";
  return (
    <div className="App">
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
      <div className="asset-container" style={{ opacity: !loading ? "1" : "0" }} onClick={onImgClick}>
        <VideoPlayer
          id="bd_video_player"
          className="content video-content"
          pauseVideo={false}
          src="./assets/roman passage.mp4"
          videoType="video/mp4"
          onVideoLoad={onVideoLoad}
        ></VideoPlayer>

        <div className="content image-content">
          <ImageLoader url={imgUrl} className="object-fit background-image"></ImageLoader>
        </div>
      </div>
    </div>
  );
}

export default App;
